import apiClient from '@/plugins/axios'

export default {
  getStatusProcessos() {
    return apiClient.get('statusProcesso')
  },

  getStatusProcesso(id) {
    return apiClient.get(`statusProcesso/${id}`)
  },

  postStatusProcesso(statusProcesso) {
    return apiClient.post(`statusProcesso`, { status_processo: statusProcesso })

  },

  putStatusProcesso(id, statusProcesso) {
    return apiClient.put(`statusProcesso/${id}`, { status_processo: statusProcesso })

  },

  deleteStatusProcesso(id) {
    return apiClient.delete(`statusProcesso/${id}`)
  },

  getDropDown() {
    return apiClient.get('statusProcesso/dropdown')
  },

}


// WEBPACK FOOTER //
// ./src/views/StatusProcesso/_services/StatusProcessoService.js